import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const PaymentsAccepted = dynamic(() => import('./PaymentsAccepted').then((m) => ({ default: m.PaymentsAccepted })));

Builder.registerComponent(PaymentsAccepted, {
  name: 'PaymentsAccepted',
  friendlyName: 'Payments Accepted',
  inputs: [
    {
      name: 'title',
      type: 'string',
      required: true,
    },
    {
      name: 'description',
      type: 'string',
      required: true,
    },
    {
      name: 'footer',
      type: 'string',
      required: true,
    },
  ],
});
